const SAVED_LAST_OPENED_LIST_ITEM_KEY_PREFIX = 'contrak:lastOpenedListItem:';

function getStorageKey(pageKey: string): string {
  return `${SAVED_LAST_OPENED_LIST_ITEM_KEY_PREFIX}${pageKey}`;
}

/** Id of the list item last opened on this page in this browser tab, or null when none */
export function loadSavedLastOpenedListItemId(pageKey: string): string | null {
  try {
    return sessionStorage.getItem(getStorageKey(pageKey));
  } catch {
    // ignore private mode / blocked storage
    return null;
  }
}

export function saveLastOpenedListItemId(pageKey: string, itemId: string | number): void {
  try {
    sessionStorage.setItem(getStorageKey(pageKey), String(itemId));
  } catch {
    // ignore private mode / blocked storage
  }
}

export function getIsLastOpenedListItem(
  lastOpenedItemId: string | null,
  itemId: string | number | null | undefined,
): boolean {
  return lastOpenedItemId !== null && itemId !== null && itemId !== undefined
    && lastOpenedItemId === String(itemId);
}
